import React, { Component } from 'react'
import EntityList from './../../components/entityList';

class Flags extends Component {
  render() {
    return (
      <EntityList apiRoute='api/flags' title='Remorque - Flags' editTitle='Flag' displayColumns={[
        {Description: 'Description', Column: 'Description'},
        {Description: 'Inactif', Column: 'Inactive', sortable: false, format: {type: 'boolean'}}
      ]}/>
    )
  }
}

export default Flags;


/** WEBPACK FOOTER **
 ** ./src/app/routes/trailers/flags.js
 **/